export default function EquipmentStatusComponent() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      equipment: '=',
      pullRight: '='
    },
    template: require('./equipment-status.html')
  };
}
